import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import '../../static/Header.css';
import '../../static/Global.css';

function Header() {
  const [cartCount, setCartCount] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  // Calcular la cantidad total de productos en el carrito
  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem('mediexpress_cart')) || [];
    const totalItems = cart.reduce((acc, item) => acc + (Number(item.cantidad) || 1), 0);
    setCartCount(totalItems);
  };

  useEffect(() => {
    updateCartCount();

    window.addEventListener('storage', updateCartCount);
    window.addEventListener('cartUpdated', updateCartCount);

    const handleScroll = () => {
      if (window.scrollY > 30) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', updateCartCount);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`boutique-header ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="container boutique-header-container">
        
        {/* LOGO BOUTIQUE MINIMALISTA */}
        <div className="boutique-brand">
          <Link to="/" className="boutique-logo-link">
            <span className="brand-accent-dot"></span>
            <h1 className="boutique-brand-title">YCore</h1>
            <span className="boutique-sub">Studio</span>
          </Link>
        </div>

        {/* ACCIONES EXCLUSIVAS (CARRITO Y LOGIN) - SIN BOTONES DE OTRAS PÁGINAS */}
        <div className="boutique-actions">
          

          {/* Acceso Usuario */}
          <Link 
            className="boutique-action-btn user-btn-boutique" 
            to="/Login" 
            title="Mi Cuenta"
            aria-label="Iniciar Sesión"
          >
            <i className="fa-regular fa-user"></i>
          </Link>

        </div>

      </div>
    </header>
  );
}

export default Header;